import { useEffect, useState } from "react";
import { Container, Grid, Typography } from "@mui/material";
import ProductInfo from "../components/Product/ProductInfo";
import ProductCard from '../components/ProductCard';
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useProductStore } from "../store/useProductStore";
import Loader from "../components/Loader/Loader";
import ProductFullDetails from "../components/ProductFullDetails";

const ProductDetails = () => {
  const location = useLocation();

  const navigate = useNavigate()
  const { state } = useLocation();
  const { id } = useParams();
  const [showDetails, setShowDetails] = useState(true);
  const [loadingStyle, setLoadingStyle] = useState(false);
  const { getProductById, selectedProduct, product, loading, getSuggestedProduct, suggestedProduct } = useProductStore()


  const handleGetDetailProduct = (id) => {
    navigate(`/product-details/${id}`);
  }

  const getDetailFunction = async () => {
    if (id) {
      setLoadingStyle(true)
      await getProductById(id)
      await getSuggestedProduct(id)
      setLoadingStyle(false)
    } else {
      console.log("dsomething went wrong")
    }
  }

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    getDetailFunction()
  }, [location.pathname]);


  return (
    <>
      <Loader loading={loadingStyle} />
      <Container maxWidth="xl">
        <ProductInfo />

        {/* {!showDetails && (
          <Typography
            onClick={() => setShowDetails(true)}
            sx={{
              cursor: "pointer",
              color: "#1976d2",
              textDecoration: "underline",
              marginTop: "20px",
              marginBottom: "10px",
              fontWeight: 500
            }}
          >
            See More Details
          </Typography>
        )}

        {showDetails && <ProductFullDetails selectedProduct={selectedProduct} />}
        {showDetails && <Typography
          onClick={() => setShowDetails(false)}
          sx={{
            cursor: "pointer",
            color: "#1976d2",
            textDecoration: "underline",
            marginTop: "20px",
            marginBottom: "10px",
            fontWeight: 500
          }}
        >
          See Less Details
        </Typography>} */}
        <ProductFullDetails selectedProduct={selectedProduct} />
        <Typography
          className="titleSec"
          sx={{
            marginBottom: "30px",
            marginTop: "60px",
          }}
        >
          Suggested Items
        </Typography>
        <Grid container spacing={3} sx={{ marginBottom: "90px" }}>
          {(suggestedProduct || []).map((productDetail, index) => (
            <Grid
              item
              size={{ xs: 12, sm: 6, md: 3, lg: 3 }}
              onClick={() => handleGetDetailProduct(productDetail?._id)}
            >
              <ProductCard key={index} productDetail={productDetail} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </>
  );
};

export default ProductDetails;
